itemizedReport<template>
  <div class="report-wrap">
    <div class=" content">
      <div class="title-wrap dn-content-bg">
            <time-search
                    ref="timeSearch"
                    :control="{data:timeData}"
                    @timeControlChange="timeControlChange"
                    @timeControlClick="TimeControlClick"
                    :showExportBtn="true"
                    :showPrint="true"
                    :showType="false"
                    :showPrintId="'table'"
                    :showPrintTitle="'告警报表'"
                    @exportExc="bindExportExc"
                >
            </time-search>
        <div>
        </div>
      </div>
      <div class="table-content  box"  style="flex: 1;display: flex;">
        <nk-table
          id="table"
          :data="tableData"
          :emptyText="'暂无告警'"
          :columns="columns"
          :showPage="true"
          :page="page"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
        >
        </nk-table>
      </div>
    </div>
  </div>
</template>

<script>
import {
  findDataByParam,
  dateToColumns,
  toPage,
  exportExcel,
} from "@/utils/index.js";
import { EVEN } from "@/config/data.js";
import NkTable from "@/components/common/NkTable";
import TimeSearch from "@/components/common/TimeSearch.vue";
import tree from '@/utils/tree'
import dateTool from "@/utils/dateTool";
let allTimeData = [
        // {
        //     type: "day",
        //     label: "日",
        // },
        // {
        //     type: "month",
        //     label: "月",
        // },
        {
            type: "timeInterval",
            label: "时段",
        },
        // {
        //     type: "year",
        //     label: "年",
        // },
    ];
export default {
    components: { NkTable,TimeSearch },
    data() {
        return {
            timeData: allTimeData,
            selectedDate: {},
            tableData:[],
            columns:[],
            page: {
                pageSizes: [10, 20, 50, 100, 500, 1000], //每页显示条目个数
                size: 10,
                total: 0,
                pageIndex: 1,
            },
            evenTableData: [],
            evenData: EVEN,
            actionData: [
                { type: 6, label: "遥测量告警" },
                { type: 7, label: "遥信量告警" },
                { type: 8, label: "通信告警" },
                { type: 9, label: "限额告警" },
                { type: 10, label: "系统告警" },
            ],
            levelData:[
                {
                    level:1,label:'一级'
                },
                {
                    level:2,label:'二级'
                },
                {
                    level:3,label:'三级'
                },
                {
                    level:4,label:'四级'
                },
                {
                    level:5,label:'五级'
                },
                {
                    level:6,label:'六级'
                }
            ]
        }
    },
    created() {
        let vm=this
        let time = new Date();
        let endTime = dateTool.format(time, "yyyy-MM-dd hh:mm:ss");
        time.setDate(time.getDate() -1);
        let startTime = dateTool.format(time, "yyyy-MM-dd hh:mm:ss");
        vm.selectedDate = {
            dataType: "1",
            dateType: "timeInterval",
            endTime: endTime,
            startTime: startTime,
        };
        vm.TimeControlClick(vm.selectedDate);
    },
    mounted() {},
    watch: {},
    methods: {
        timeControlChange() {},
        //查询事件
        TimeControlClick(e) {
            let vm = this;
            vm.selectedDate = e;
            vm.$api.event
                .getEventRecord(
                this.$store.state.user.currentCompanyId,
                null,
                null,
                null,
                null,
                null,
                null,
                e.startTime,
                e.endTime
                )
                .then((res) => {
                if (res) {
                    let data = [];
                    res.data.forEach((obj) => {
                        let codeTitle = vm.evenData.find((e) => e.id == obj.code);
                        let actionTitle = vm.actionData.find((e) => e.type == obj.type);
                        let levels = vm.levelData.find((e) => e.level == obj.level); 
                        let warnState = 0;
                        const eventItem = vm.evenData.find(
                            (item) => item.id == obj.code
                        );
                        obj.confirmingUserId=!obj.confirmingUserId||obj.confirmingUserId=='0'?'未确认':'已确认'
                        obj.handlingUserId=!obj.handlingUserId||obj.handlingUserId=='0'?'未处理':'已处理'
                        obj.codeTitle = codeTitle ? codeTitle.label : "";
                        obj.actionTitle = actionTitle ? actionTitle.label : "";
                        obj.level = levels ? levels.label : "";
                        data.push(obj);
                    });
                    vm.evenTableData = data;
                    vm.getData(1)
                }
            });
        },
        //获取左边数据
        async getData(pageIndex) {
            let tableData = [];
            let columns =[
                    { label: "序号",fixed: "left",show: true, width:"100",type:'index',align: "center",},
                    {label: "告警源",show: true,prop: "measureName",},
                    { prop: "codeTitle", label: "告警名称", show: true },
                    { prop: "content", label: "告警内容", show: true },
                    {prop: "eventTime",label: "发生时间",show: true,},
                    {prop: "level",label: "告警级别",show: true,},
                    { prop: "actionTitle", label: "告警类型", show: true },
                    {prop: "confirmingUserNickname",label: "确认人",show: true},
                    {prop: "confirmingUserId",label: "确认状态",show: true},
                    {prop: "confirmingTime",label: "确认时间",show: true,},
                    {prop: "handlingUserNickname",label: "处理人",show: true,},
                    {prop: "handlingUserId",label: "处理状态",show: true,},
                    { prop: "handlingTime",label: "处理时间",show: true,}
                ];
                this.columns=columns
                this.page.pageIndex = pageIndex;
                this.page.total = this.evenTableData.length;
                this.tableData = this.evenTableData.slice(
                    (pageIndex - 1) * this.page.size,
                    pageIndex * this.page.size
                );
        },
        bindExportExc() {
            //表格导出
            console.log(this.selectedDate)
            exportExcel("table", '告警报表', this.selectedDate);
        },
        handleCurrentChange(val) {
            this.getData(val);
        },
        handleSizeChange(val) {
            this.page.size = val;
            this.getData(1);
        },
    },
};
</script>
<style lang="scss" scoped>
@page {
    size: auto;  /* auto is the initial value */
    margin: 0mm; /* this affects the margin in the printer settings */
}
.btn{
    background: #5fa4e8;
    color: #fff;
}
.black{
    color: #fff;
}
.report-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 14px;
  box-sizing: border-box;
  text-align: left;
  .content {
    display: flex;
    flex-flow: column;
    width: 100%;
  }
  .title-wrap {
    width: 100%;
    height: 50px;
    line-height: 40px;
    border-bottom: 1px solid rgb(214, 214, 214);
    margin-bottom: 14px;
    color: #000;
    display: flex;
    align-items: center;
    .title-content {
      font-weight: bold;
    }
  }
  .list1{
        display: flex;
        flex:1;
        flex-wrap: wrap;
        color:#000;
        .item{
            display: flex;
            align-items: center;
            border: 1px solid #5f5f5f;
            padding: 0px 6px;
            margin: 5px;
            .item-title{
                margin-right: 10px;
            }
        }
    }
}
.rows{
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}
.addRow{
    margin-left: 67px;
    border: 1px dashed #797979;
    text-align: center;
    padding: 5px;
    margin-right: 87px;
    cursor: pointer;
}
.addRow1{
    margin-left: 38px;
    border: 1px dashed #797979;
    text-align: center;
    padding: 5px;
    margin-right: 18px;
    cursor: pointer;
}
.maxHeight{
    max-height: 350px;
    overflow: auto;
}
.treeBox{
    max-height: 450px;
    overflow: auto;
}
.layou-container {
    overflow: none;
    text-overflow: none;
    white-space: ''
}
.verticalSave{
    margin-left:262px;margin-top:10px
}
.mesureName{
    max-width:200px;white-space: break-spaces;margin-right:7px
}
.time-warp{
    width: 100%;
    height: 100%;
    padding: 0px 10px;
    box-sizing: border-box;
    align-items: center;
    display: flex;
}
</style>